import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProducts } from "./../../constants";
import { getProductsFilterMetaResponse } from "./getProductsFilterMeta.types";

export const requestGetProductsFilterMeta = async (
  subChildCategoryId: string
): Promise<getProductsFilterMetaResponse> => {
  return await instance.get(
    buildUrl(ApiRoutesProducts.ProductFilterMeta, subChildCategoryId)
  );
};
